module.exports = __webpack_public_path__ + "static/media/eight.66dca14d.svg";